import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatDate, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher, FaChevronDown } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import OneClassroom from '../ones/OneClassroom';
import { MdArrowDownward, MdCheck, MdSms, MdWhatsapp } from "react-icons/md";
import ClassroomRegistrationForm from "../ones/ClassroomRegistrationForm";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	const [name, setName] = useState("");
	const [applyStreams, setApplyStreams] = useState("no");
	const [supportedSubjects, setSupportedSubjects] = useState([]);

	const [searchFilter, setSearchFilter] = useState("");

	async function init() {
		//run initializations here
		setReady(false);
		await appContext.getAllClassrooms();
		setReady(true);
	}

	function resetClassroomForm() {
		setName("");
		setApplyStreams('no');
		setSupportedSubjects([]);
	}

	async function createClassroom() {
		if(name.trim().length > 0) {
			setLoading(true);
			await callApi(
				'create-classroom',
				{
					name,
					applyStreams,
					supportedSubjects: JSON.stringify(supportedSubjects),
					schoolUuid: appContext.currentSchoolUuid,
				}
			).then(response => {
				if(response.status === 1) {
					appContext.getAllClassrooms();
					appContext.tellMessage("Successful");
					resetClassroomForm()
				} else {
					appContext.tellError(response.msg)
				}
			})
			setLoading(false);
		} else {
			appContext.tellError("Invalid name");
		}
	}

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		//..
	}, [appContext.allClassrooms])


	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready && appContext.allClassrooms) {
		return (
			<div
				className="container"
			>
				<div className="row">
					<div className="col-md-12">
						<h6 className="main-section-title">
							Classrooms
						</h6>
					</div>

					<div className="col-12 col-md-12">
						<div
							className="card"
						>
							<div className="card-body">
								<div 
									className="d-flex justify-content-between"
									style={{
										cursor: "pointer",
									}}
									data-bs-toggle="collapse" 
									data-bs-target="#_classroomRegForm" 
									aria-expanded="false" 
									aria-controls="_classroomRegForm"
								>
									<h6
										className="sub-section-title align-self-center"
									>
										Register New Classroom
									</h6>

									<FaChevronDown
										size={24}
										className="align-self-center text-secondary"
									/>
								</div>
								
								<div className="collapse" id="_classroomRegForm">
									<hr/>
									<ClassroomRegistrationForm/>
								</div>
								
								
							</div>
						</div>
					</div>

					<div className="col-md-12" id="_coinsOrdersList">
						<div
							className="card"
						>
							<div className="card-body">

								<div className="d-flex justify-content-between mb-4">

									<h6
										className="sub-section-title"
										
									>
										All Classrooms
									</h6>

									<input
										className="form-control mNoMargin align-self-center"
										style={{
											width: "150px"
										}}
										value={searchFilter}
										onChange={(e) => setSearchFilter(e.target.value)}
										placeholder="Filter by name"
									/>

								</div>
								<hr/>

								{
									(appContext.allClassrooms && appContext.allClassrooms.length > 0) ?
										appContext.allClassrooms.map((item, i) => {
											if (searchFilter) {
												if (
													String(item.name).toLowerCase().indexOf(String(searchFilter).toLowerCase()) > -1 
												) {
													return (
														<OneClassroom data={item} key={i} />
													)
												} else {
													return "";
												}
											} else {
												return (
													<OneClassroom data={item} key={i} />
												)
											}
										})
										:
										<h6
											className=""
											style={{
												fontSize: "14px",
											}}
										>
											No classroom was found
										</h6>
								}
							</div>

						</div>
					</div>

				</div>

			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}